import React, { useContext, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  Grid,
  Hidden,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Chip,
  Box,
  Card,
  CardContent,
  CardActions,
  Tooltip,
  Checkbox,
} from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import SearchIcon from '@material-ui/icons/Search';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import DeleteIcon from '@material-ui/icons/Delete';
import CallMadeIcon from '@material-ui/icons/CallMade';
import PaymentIcon from '@material-ui/icons/Payment';
import PrintIcon from '@material-ui/icons/Print';
import VisibilityIcon from '@material-ui/icons/Visibility';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import InputMask from 'react-input-mask';
import { format, isValid } from 'date-fns';
import CurrencyTextField from '@unicef/material-ui-currency-textfield/dist/CurrencyTextField';

import useApi from '../../../utils/useApi';
import StoreContext from '../../Store/context';
import { isManagerOrAbove } from '../../../utils/permissionUtils';
import { fetchCepInfo } from '../../../utils/brasilApi';
import UIButtonSearch from '../../UI/Button/Search/Search';
import UIModalFilter from '../../UI/ModalFilter/UIModalFilter';
import UIContainer from '../../UI/Container/UIContainer';
import UIFormTitle from '../../UI/Form/Title/UIFormTitle';
import {
  PromissoryNotePreview,
  printPromissoryNote,
  preparePromissoryData,
} from '../../PromissoryNote/PromissoryNote';
import {
  emptyObject,
  formatClient,
  formattedCurrency,
  formattedDateTime,
  goToReferenceId,
} from '../../../utils/utils';
import UIFilter from '../../UI/Button/Filter/UIFilter';
import UIDialogConfirm from '../../UI/Dialog/Confirm/UIDialogConfirm';
import UIDialogTitle from '../../UI/Dialog/Title/UIDialogTitle';
import FormInputDate from '../../UI/Form/InputDate/FormInputDate';

const initialValues = {
  id: '',
  name: '',
  lastName: '',
  gender: '',
  marialStatus: '',
  children: 0,
  city: '',
  neighborhood: '',
  street: '',
  houseNumber: '',
  bornIn: null,
  email: '',
  whatsapp: '',
  customer_profile_id: '',
};

const initialClick = {
  mouseX: null,
  mouseY: null,
};

const initialPayment = {
  amountPaid: 0,
  plots: 1,
  paymentMethod: 6,
};

const ClientSearch = () => {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  const history = useHistory();

  // Estados globais e contexto
  const { credencials, setModalCashierSelect, searchState, setSearchState } = useContext(StoreContext);
  const isManager = isManagerOrAbove(credencials);

  // Estados de Modais
  const [viewModalItems, setViewModalItems] = useState(false);
  const [viewModalDelete, setViewModalDelete] = useState(false);
  const [viewPaymentModal, setViewPaymentModal] = useState(false);
  const [viewPromissoryModal, setViewPromissoryModal] = useState(false); // Novo estado para pré-visualização
  const [modalPay, setModalPay] = useState(false);
  const [filter, setFilter] = useState(false);

  // Estados de Dados
  const [modalValues, setModalValues] = useState(null);
  const [search, setSearch] = useState(null);
  const [payment, setPayment] = useState(initialPayment);
  const [salesTotal, setSalesTotal] = useState(0);

  // Novo estado para a data de vencimento da promissória
  const [promissoryDueDate, setPromissoryDueDate] = useState(new Date());

  // Feedback e Controle
  const [alert, setAlert] = useState(false);
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [loadingSales, setLoadingSales] = useState(false);
  const [clickRight, setClickRight] = useState(initialClick);
  const [anchorEl, setAnchorEl] = useState(null);

  // APIs
  const [filterLoad, filterInfo] = useApi({
    debounceDelay: 500,
    method: 'get',
    url: '/customers',
  });

  const [updateLoad, updateInfo, setUpdateInfo] = useApi({
    method: 'put',
    url: '/customers',
    onCompleted: (response) => {
      if (response) filterLoad({ params: search });
    },
  });

  const [salesLoad, salesInfo] = useApi({
    method: 'get',
    url: '/sales',
    onCompleted: (response) => {
      setLoadingSales(false);
      if (response) {
        // Calcula o total pendente (valor total - valor pago) apenas de vendas abertas
        const total = response.data.reduce((acc, curr) => {
          if (curr.isClosed == 1) return acc;
          const pending = parseFloat(curr.value) - parseFloat(curr.amountPaid);
          return acc + pending;
        }, 0);

        setSalesTotal(total || 0);
        changeValuesPayment(total, 'amountPaid');
      } else {
        setSalesTotal(0);
      }
    },
  });

  const [userLoad, userInfo] = useApi({
    method: 'get',
    url: '/users',
  });

  const [profilesLoad, profilesInfo] = useApi({
    method: 'get',
    url: '/customers/profiles',
  });

  const [deleteLoad, deleteInfo, setDeleteInfo] = useApi({
    method: 'delete',
    url: '/customers',
    onCompleted: (response) => {
      if (response) filterLoad({ params: search });
    },
  });

  const [paymentLoad, paymentInfo] = useApi({
    method: 'get',
    url: '/payments/methods',
  });

  const [payLoad, payInfo, setPayInfo] = useApi({
    method: 'patch',
    url: '/sales',
  });

  useEffect(() => {
    const { clientSearch } = searchState;
    if (clientSearch) {
      if (clientSearch.search) {
        setSearch(clientSearch.search);
        filterLoad({ params: clientSearch.search });
      } else {
        filterLoad();
      }
      if (clientSearch.viewPaymentModal) {
        setViewPaymentModal(true);
        if (clientSearch.modalValues?.id) {
          setLoadingSales(true);
          callSalesByCustomerService(clientSearch.modalValues.id);
        }
      }
      if (clientSearch.modalValues) setModalValues(clientSearch.modalValues);
    } else {
      filterLoad();
    }
    userLoad();
    paymentLoad();
    profilesLoad();
  }, []);

  const updateGlobalState = (updates) => {
    setSearchState((prev) => ({
      ...prev,
      clientSearch: {
        ...(prev.clientSearch || {}),
        ...updates,
      },
    }));
  };

  function changeValuesPayment(value, attribute) {
    setPayment((prev) => ({ ...prev, [attribute]: value, errors: false }));
  }

  async function onPay() {
    if (!credencials.cashSession) {
      setModalCashierSelect(true);
      return;
    }

    if (Number(payment.amountPaid) <= 0) return;

    setLoadingPayment(true);

    let availableToPay = payment.amountPaid;

    try {
      if (salesInfo.data) {
        for (let i = 0; i < salesInfo.data.length; i++) {
          let saleData = salesInfo.data[i];

          if (!availableToPay || availableToPay <= 0.1) {
            break;
          }

          const data = {
            id: saleData.id,
            plots: 1,
            cashRegister: credencials.cashSession,
            amountPaid: availableToPay,
            paymentMethod: payment.paymentMethod,
          };

          await payLoad({
            data,
            onCompleted: (response) => {
              availableToPay = response.data?.remnant || 0;
            },
          });
        }
      }

      setModalPay(false);
      setAlert(true);

      if (modalValues && modalValues.id) {
        setLoadingSales(true);
        callSalesByCustomerService(modalValues.id);
      }
    } catch (error) {
      console.error('Erro no processo de pagamento', error);
    } finally {
      setLoadingPayment(false);
    }
  }

  function humanAttributes(values) {
    const treatmentData = {
      ...values,
      bornIn: isValid(values.bornIn)
        ? format(new Date(values.bornIn), 'yyyy-MM-dd')
        : null,
    };
    setModalValues(treatmentData);
    return treatmentData;
  }

  const handleClickRight = (event, values) => {
    event.preventDefault();
    humanAttributes(values);
    setClickRight({ mouseX: event.clientX - 2, mouseY: event.clientY - 4 });
  };

  const handleCloseClickRight = () => setClickRight(initialClick);

  const handleClickLeft = (event, values) => {
    humanAttributes(values);
    setAnchorEl(event.currentTarget);
  };

  const handleCloseClickLeft = () => setAnchorEl(null);

  function closeFloatMenuTable() {
    const closeMenu = mobile ? handleCloseClickLeft : handleCloseClickRight;
    closeMenu();
  }

  function handleModalFilter() {
    setFilter(!filter);
  }

  function handleModalUpdate(values, isClick) {
    if (values) humanAttributes(values);
    if (isClick) closeFloatMenuTable();
    const newState = !viewModalItems;
    setViewModalItems(newState);
  }

  function handleModalDelete(values, isClick) {
    if (values) humanAttributes(values);
    if (isClick) closeFloatMenuTable();
    setViewModalDelete(!viewModalDelete);
  }

  function handlePaymentModal(client, isClick) {
    if (client) humanAttributes(client);
    if (isClick) closeFloatMenuTable();

    const opening = !viewPaymentModal;
    setViewPaymentModal(opening);
    updateGlobalState({
      viewPaymentModal: opening,
      modalValues: client || modalValues,
    });
    // Resetar a data de vencimento para hoje ao abrir o modal
    setPromissoryDueDate(new Date());

    if (opening && (client?.id || modalValues?.id)) {
      setLoadingSales(true);
      callSalesByCustomerService(client?.id || modalValues?.id);
    }
  }

  function closeAlert(event, reason) {
    setUpdateInfo();
    setPayInfo();
    if (reason === 'clickaway') return;
    setAlert(false);
  }

  function fullName(values) {
    return `${values.name} ${values.lastName || ''}`;
  }

  function getUserByID(userId) {
    if (!userInfo.data?.length) return '...';
    const user = userInfo.data.find(({ id }) => id == userId);
    return user?.name || 'Desconhecido';
  }

  function callSalesByCustomerService(customerID) {
    salesLoad({ params: { isClosed: 0, customer: customerID } });
  }

  function onSubmit(values) {
    const searchValues = humanAttributes(values);
    filterLoad({
      debounced: true,
      params: emptyObject(searchValues),
    });
    setSearch(emptyObject(searchValues));
    updateGlobalState({ search: emptyObject(searchValues), initialValues: values });
  }

  function onUpdate(values) {
    const updateValues = humanAttributes(values);
    updateLoad({ data: updateValues });
    setViewModalItems(false);
    setAlert(true);
  }

  function onDelete(customerId) {
    deleteLoad({ data: { id: customerId } });
    setViewModalDelete(false);
    setAlert(true);
  }
  const getNoteData = () => {
    if (!modalValues) return null;

    return preparePromissoryData({
      client: modalValues,
      companyData: credencials.companyData, // Assumindo que credencials vem do StoreContext
      installments: [
        { value: salesTotal, dueDate: promissoryDueDate },
      ],
      emissionDate: new Date(),
    });
  };

  // Função chamada pelo botão "Confirmar Impressão"
  const handlePrintClick = () => {
    const data = getNoteData();
    if (data) {
      printPromissoryNote(data);
    }
  };

  return (
    <>
      <Formik
        enableReinitialize
        onSubmit={onSubmit}
        initialValues={searchState.clientSearch?.initialValues || initialValues}
      >
        {({ values, submitForm, setFieldValue }) => (
          <Form onChange={() => submitForm()}>
            <UIContainer container direction="row">
              <Grid
                item
                container
                justify="space-between"
                alignItems="center"
                xs={12}
              >
                <UIFormTitle title="Filtrar clientes" />
                <UIFilter onClick={handleModalFilter} />
              </Grid>
              {/* Campos de busca */}
              <Grid item xs={2} md={1}>
                <Field
                  name="id"
                  label="ID"
                  placeholder="ID"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Grid item xs={5} md={2}>
                <Field
                  name="name"
                  label="Nome"
                  placeholder="Informe o nome"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Grid item xs={5} md={3}>
                <Field
                  name="lastName"
                  label="Sobrenome"
                  placeholder="Informe o sobrenome"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Hidden smDown>
                <Grid item xs={2}>
                  <InputMask
                    value={values.whatsapp}
                    mask="(99) 9 9999-9999"
                    onChange={(ev) =>
                      setFieldValue(
                        'whatsapp',
                        ev.target.value.replace(/[^0-9]/g, ''),
                      )
                    }
                  >
                    {() => (
                      <TextField
                        label="Whatsapp"
                        placeholder="Informe o numero"
                        fullWidth
                      />
                    )}
                  </InputMask>
                </Grid>
                <Grid item xs={3}>
                  <FormControl fullWidth>
                    <InputLabel shrink id="client-search-profile">
                      Perfil de Cliente
                    </InputLabel>
                    <Field
                      name="customer_profile_id"
                      labelId="client-search-profile"
                      displayEmpty
                      fullWidth
                      as={Select}
                      disabled={profilesInfo.loading}
                    >
                      <MenuItem value="" defaultValue>
                        <em>-</em>
                      </MenuItem>
                      {profilesInfo.data &&
                        profilesInfo.data.map &&
                        profilesInfo.data.map((p) => (
                          <MenuItem key={p.id} value={p.id}>
                            {p.name}
                          </MenuItem>
                        ))}
                    </Field>
                  </FormControl>
                </Grid>
                
                <UIButtonSearch xs={1} />
              </Hidden>
            </UIContainer>

            <UIModalFilter
              open={filter}
              changeModal={handleModalFilter}
              submit={submitForm}
            >
              <Grid item xs={12}>
                <Field
                  name="email"
                  label="E-mail"
                  type="email"
                  placeholder="Informe o e-mail"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Hidden mdUp>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <InputLabel shrink id="client-search-profile-mobile">
                      Filtrar por Perfil de Cliente
                    </InputLabel>
                    <Field
                      name="customer_profile_id"
                      labelId="client-search-profile-mobile"
                      displayEmpty
                      fullWidth
                      as={Select}
                      disabled={profilesInfo.loading}
                    >
                      <MenuItem value="" defaultValue>
                        <em>-</em>
                      </MenuItem>
                      {profilesInfo.data &&
                        profilesInfo.data.map &&
                        profilesInfo.data.map((p) => (
                          <MenuItem key={p.id} value={p.id}>
                            {p.name}
                          </MenuItem>
                        ))}
                    </Field>
                  </FormControl>
                </Grid>
              </Hidden>
              <Hidden mdUp>
                <Grid item xs={12}>
                  <InputMask
                    value={values.whatsapp}
                    mask="(99) 9 9999-9999"
                    onChange={(ev) =>
                      setFieldValue(
                        'whatsapp',
                        ev.target.value.replace(/[^0-9]/g, ''),
                      )
                    }
                  >
                    {() => <TextField label="Whatsapp" fullWidth />}
                  </InputMask>
                </Grid>
              </Hidden>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel shrink id="client-search-gender">
                    Gênero
                  </InputLabel>
                  <Field
                    name="gender"
                    labelId="client-search-gender"
                    displayEmpty
                    fullWidth
                    as={Select}
                  >
                    <MenuItem value="">
                      <em>Selecione o gênero</em>
                    </MenuItem>
                    <MenuItem value={1}>Masculino</MenuItem>
                    <MenuItem value={2}>Feminino</MenuItem>
                    <MenuItem value={3}>Indefinido</MenuItem>
                  </Field>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <FormControl fullWidth>
                  <InputLabel shrink id="client-search-marialStutus">
                    Estado civil
                  </InputLabel>
                  <Field
                    name="marialStatus"
                    labelId="client-search-marialStutus"
                    displayEmpty
                    fullWidth
                    as={Select}
                  >
                    <MenuItem value="">
                      <em>Selecione estado civil</em>
                    </MenuItem>
                    <MenuItem value={1}>Solteiro</MenuItem>
                    <MenuItem value={2}>Casado</MenuItem>
                    <MenuItem value={3}>Divorciado</MenuItem>
                  </Field>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Field
                  name="children"
                  type="number"
                  label="Filhos"
                  placeholder="Numero de filhos"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Grid item xs={6}>
                <Field
                  name="houseNumber"
                  label="Número"
                  placeholder="Informe o numero da casa"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Grid item xs={6}>
                <Field
                  name="neighborhood"
                  label="Bairro"
                  placeholder="Informe o nome da bairro"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Grid item xs={6}>
                <Field
                  name="street"
                  label="Rua / Avenida"
                  placeholder="Informe o nome da rua"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Grid item xs={6}>
                <Field
                  name="city"
                  label="Cidade"
                  placeholder="Informe o nome da cidade"
                  fullWidth
                  as={TextField}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormInputDate
                  value={values.bornIn}
                  clearable
                  label="Data de nascimento"
                  placeholder="Informe a data nascimento"
                  onChange={(value) => setFieldValue('bornIn', value)}
                />
              </Grid>
            </UIModalFilter>
          </Form>
        )}
      </Formik>

      <UIContainer>
        <Grid item xs={12}>
          <UIFormTitle title="Lista de clientes" />
        </Grid>

        {/* Tabela Desktop */}
        <Grid item xs={12}>
          <Hidden smDown>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Nome</TableCell>
                    <TableCell>Nascimento</TableCell>
                    <TableCell>Nº Whatsapp</TableCell>
                    <TableCell align="right">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filterInfo.loading && (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        <CircularProgress />
                      </TableCell>
                    </TableRow>
                  )}
                  {filterInfo.data &&
                    filterInfo.data.map((data) => (
                      <TableRow
                        onDoubleClick={() => handleModalUpdate(data)}
                        onContextMenu={
                          !mobile ? (ev) => handleClickRight(ev, data) : undefined
                        }
                        style={{ cursor: 'context-menu' }}
                        onClick={
                          mobile ? (ev) => handleClickLeft(ev, data) : undefined
                        }
                        hover
                        key={data.id}
                      >
                        <TableCell component="th" scope="row">
                          {data.id}
                        </TableCell>
                        <TableCell>{fullName(data)}</TableCell>
                        <TableCell>{data.bornIn || '---'}</TableCell>
                        <TableCell>{data.whatsapp || '---'}</TableCell>
                        <TableCell align="right">
                          <Tooltip title="Visualizar/Editar">
                            <IconButton
                              size="small"
                              onClick={() => handleModalUpdate(data)}
                            >
                              <SearchIcon />
                            </IconButton>
                          </Tooltip>
                          {isManager && (
                            <Tooltip title="Analisar com DuxIA">
                              <IconButton
                                size="small"
                                component={Link}
                                to={`/home/clientes/analise/${data.id}`}
                              >
                                <VisibilityIcon color="inherit" />
                              </IconButton>
                            </Tooltip>
                          )}
                          <Tooltip title="Visualizar compras">
                            <IconButton
                              size="small"
                              onClick={() => handlePaymentModal(data)}
                            >
                              <AttachMoneyIcon color="primary" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Excluir">
                            <IconButton
                              size="small"
                              onClick={() => handleModalDelete(data)}
                            >
                              <DeleteIcon color="error" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))}
                  <Menu
                    keepMounted
                    open={clickRight.mouseY !== null}
                    onClose={handleCloseClickRight}
                    anchorReference="anchorPosition"
                    anchorPosition={
                      clickRight.mouseY !== null
                        ? { top: clickRight.mouseY, left: clickRight.mouseX }
                        : undefined
                    }
                  >
                    <MenuItem onClick={() => handleModalUpdate(null, true)}>
                      Visualizar/Editar
                    </MenuItem>
                    <MenuItem onClick={() => handlePaymentModal(null, true)}>
                      Visualizar compras
                    </MenuItem>
                    {isManager && (
                      <MenuItem
                        onClick={() => {
                          handleCloseClickRight();
                          history.push(
                            `/home/clientes/analise/${modalValues?.id}`,
                          );
                        }}
                      >
                        Analisar com DuxIA
                      </MenuItem>
                    )}
                  </Menu>
                  <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleCloseClickLeft}
                  >
                    <MenuItem onClick={() => handleModalUpdate(null, true)}>
                      Visualizar/Editar
                    </MenuItem>
                    <MenuItem onClick={() => handlePaymentModal(null, true)}>
                      Visualizar compras
                    </MenuItem>
                    {isManager && (
                      <MenuItem
                        onClick={() => {
                          handleCloseClickLeft();
                          history.push(
                            `/home/clientes/analise/${modalValues?.id}`,
                          );
                        }}
                      >
                        Analisar com DuxIA
                      </MenuItem>
                    )}
                  </Menu>
                </TableBody>
              </Table>
            </TableContainer>
          </Hidden>

          {/* Cards Mobile */}
          <Hidden mdUp>
            {filterInfo.loading && (
              <Box display="flex" justifyContent="center" my={3}>
                <CircularProgress />
              </Box>
            )}
            {filterInfo.data &&
              filterInfo.data.map((data) => {
                const profileName = profilesInfo.data?.find(
                  (p) => p.id === data.customer_profile_id,
                )?.name;
                const statusColor = '#17497F';

                return (
                  <Card
                    key={data.id}
                    variant="outlined"
                    style={{
                      marginBottom: 12,
                      borderLeft: `4px solid ${statusColor}`,
                      backgroundColor: '#FFFFFF',
                      borderRadius: 8,
                    }}
                  >
                    <CardContent style={{ paddingBottom: 8 }}>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={1}
                      >
                        <Typography
                          variant="subtitle1"
                          style={{ fontWeight: 'bold', color: '#182F48' }}
                        >
                          #{data.id} - {fullName(data)}
                        </Typography>
                        {profileName && (
                          <Chip
                            label={profileName}
                            size="small"
                            variant="outlined"
                            style={{
                              borderColor: '#17497F',
                              color: '#17497F',
                              fontWeight: 600,
                            }}
                          />
                        )}
                      </Box>
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <Typography variant="body2" color="textSecondary">
                            Nascimento: <strong>{data.bornIn || '---'}</strong>
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2" color="textSecondary">
                            Whatsapp: <strong>{data.whatsapp || '---'}</strong>
                          </Typography>
                        </Grid>
                        {(data.city || data.neighborhood || data.street) && (
                          <Grid item xs={12}>
                            <Typography variant="body2" color="textSecondary">
                              Endereço:{' '}
                              <strong>
                                {[
                                  data.street,
                                  data.houseNumber,
                                  data.neighborhood,
                                  data.city,
                                ]
                                  .filter(Boolean)
                                  .join(', ')}
                              </strong>
                            </Typography>
                          </Grid>
                        )}
                      </Grid>
                    </CardContent>
                    <CardActions
                      style={{
                        justifyContent: 'flex-end',
                        paddingTop: 0,
                        paddingBottom: 8,
                      }}
                    >
                      <Tooltip title="Visualizar/Editar">
                        <IconButton
                          size="small"
                          onClick={() => handleModalUpdate(data)}
                        >
                          <SearchIcon />
                        </IconButton>
                      </Tooltip>
                      {isManager && (
                        <Tooltip title="Analisar com DuxIA">
                          <IconButton
                            size="small"
                            component={Link}
                            to={`/home/clientes/analise/${data.id}`}
                          >
                            <VisibilityIcon color="inherit" />
                          </IconButton>
                        </Tooltip>
                      )}
                      <Tooltip title="Visualizar compras">
                        <IconButton
                          size="small"
                          onClick={() => handlePaymentModal(data)}
                        >
                          <AttachMoneyIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Excluir">
                        <IconButton
                          size="small"
                          onClick={() => handleModalDelete(data)}
                        >
                          <DeleteIcon color="error" />
                        </IconButton>
                      </Tooltip>
                    </CardActions>
                  </Card>
                );
              })}
          </Hidden>
        </Grid>
      </UIContainer>

      {/* Modal de Deleção */}
      {modalValues && (
        <Dialog
          open={viewModalDelete}
          onClose={() => setViewModalDelete(false)}
        >
          <UIDialogTitle>
            Excluir {modalValues.name} {modalValues.lastName}?
          </UIDialogTitle>
          <DialogContent>
            <DialogContentText>
              Certifique-se de que este cliente não possui vendas vinculadas
              antes de excluir.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setViewModalDelete(false)} color="primary">
              Cancelar
            </Button>
            <Button onClick={() => onDelete(modalValues.id)} color="secondary">
              Excluir
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Modal de Edição */}
      {modalValues && (
        <Dialog
          open={viewModalItems}
          onClose={() => setViewModalItems(false)}
          fullWidth
          maxWidth="md"
        >
          <Formik
            enableReinitialize
            onSubmit={onUpdate}
            initialValues={modalValues}
          >
            {({ values, errors, setFieldValue, submitForm }) => (
              <Form>
                <UIDialogTitle onClose={() => setViewModalItems(false)}>
                  {fullName(modalValues)}
                </UIDialogTitle>
                <DialogContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Field
                        name="name"
                        label="Nome"
                        error={Boolean(errors.name)}
                        helperText={errors.name}
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Field
                        name="lastName"
                        label="Sobrenome"
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Field
                        name="email"
                        label="E-mail"
                        type="email"
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputMask
                        value={values.whatsapp}
                        mask="(99) 9 9999-9999"
                        onChange={(ev) =>
                          setFieldValue(
                            'whatsapp',
                            ev.target.value.replace(/[^0-9]/g, ''),
                          )
                        }
                      >
                        {() => <TextField label="Whatsapp" fullWidth />}
                      </InputMask>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <InputLabel shrink id="client-edit-gender">
                          Gênero
                        </InputLabel>
                        <Field
                          name="gender"
                          labelId="client-edit-gender"
                          displayEmpty
                          fullWidth
                          as={Select}
                        >
                          <MenuItem value="">
                            <em>Selecione o gênero</em>
                          </MenuItem>
                          <MenuItem value={1}>Masculino</MenuItem>
                          <MenuItem value={2}>Feminino</MenuItem>
                          <MenuItem value={3}>Indefinido</MenuItem>
                        </Field>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <InputLabel shrink id="client-edit-marialStatus">
                          Estado civil
                        </InputLabel>
                        <Field
                          name="marialStatus"
                          labelId="client-edit-marialStatus"
                          displayEmpty
                          fullWidth
                          as={Select}
                        >
                          <MenuItem value="">
                            <em>Selecione estado civil</em>
                          </MenuItem>
                          <MenuItem value={1}>Solteiro</MenuItem>
                          <MenuItem value={2}>Casado</MenuItem>
                          <MenuItem value={3}>Divorciado</MenuItem>
                        </Field>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <Field
                        name="cpf"
                        type="number"
                        label="CPF"
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Field
                        name="children"
                        type="number"
                        label="Filhos"
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <InputMask
                        value={values.cep || ''}
                        mask="99999-999"
                        onChange={(ev) => {
                          const rawValue = ev.target.value;
                          setFieldValue('cep', rawValue);
                          const clean = rawValue.replace(/\D/g, '');
                          if (clean.length === 8) {
                            fetchCepInfo(clean)
                              .then((data) => {
                                if (data.street) setFieldValue('street', data.street);
                                if (data.neighborhood) setFieldValue('neighborhood', data.neighborhood);
                                if (data.city) setFieldValue('city', data.city);
                              })
                              .catch(() => {});
                          }
                        }}
                      >
                        {() => (
                          <TextField
                            label="CEP"
                            placeholder="00000-000"
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                          />
                        )}
                      </InputMask>
                    </Grid>
                    <Grid item xs={6}>
                      <Field
                        name="houseNumber"
                        label="Número"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Field
                        name="neighborhood"
                        label="Bairro"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Field
                        name="street"
                        label="Rua / Avenida"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Field
                        name="city"
                        label="Cidade"
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        as={TextField}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <FormInputDate
                        value={values.bornIn}
                        label="Nascimento"
                        onChange={(value) => setFieldValue('bornIn', value)}
                      />
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  {JSON.stringify(values) !== JSON.stringify(modalValues) && (
                    <Button onClick={() => handleModalUpdate()} color="primary">
                      Cancelar
                    </Button>
                  )}
                  <Button
                    onClick={
                      JSON.stringify(values) === JSON.stringify(modalValues)
                        ? () => handleModalUpdate()
                        : () => submitForm()
                    }
                    color="primary"
                  >
                    {JSON.stringify(values) === JSON.stringify(modalValues)
                      ? 'Fechar'
                      : 'Salvar'}
                  </Button>
                </DialogActions>
              </Form>
            )}
          </Formik>
        </Dialog>
      )}

      {/* Modal de Pagamento */}
      <Dialog open={modalPay} onClose={() => setModalPay(false)} fullWidth>
        <UIDialogTitle onClose={() => setModalPay(false)}>
          Receber {formattedCurrency(salesTotal)} de {modalValues?.name}
        </UIDialogTitle>
        <DialogContent>
          <DialogContentText>
            O sistema irá distribuir este valor automaticamente entre as vendas
            pendentes mais antigas.
          </DialogContentText>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel shrink>Método de pagamento</InputLabel>
                <Select
                  value={payment.paymentMethod}
                  onChange={(ev) =>
                    changeValuesPayment(ev.target.value, 'paymentMethod')
                  }
                  displayEmpty
                >
                  {paymentInfo.data?.map((pay) => (
                    <MenuItem key={pay.id} value={pay.id}>
                      {pay.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <CurrencyTextField
                value={payment.amountPaid}
                label="Valor a Pagar"
                variant="standard"
                currencySymbol="R$"
                outputFormat="string"
                onChange={(ev, value) =>
                  changeValuesPayment(value, 'amountPaid')
                }
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalPay(false)} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={onPay}
            color="primary"
            variant="contained"
            autoFocus
            disabled={loadingPayment || Number(payment.amountPaid) <= 0}
            startIcon={
              loadingPayment ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <PaymentIcon />
              )
            }
          >
            {loadingPayment ? 'Processando...' : 'Receber'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Novo Modal de Pré-visualização da Promissória */}
      <Dialog
        open={viewPromissoryModal}
        onClose={() => setViewPromissoryModal(false)}
        maxWidth="md"
        fullWidth
      >
        <UIDialogTitle onClose={() => setViewPromissoryModal(false)}>
          Visualizar Nota Promissória
        </UIDialogTitle>

        <DialogContent style={{ backgroundColor: '#eee', padding: '30px' }}>
          {/* Verifica se modalValues existe antes de renderizar */}
          {modalValues && <PromissoryNotePreview data={getNoteData()} />}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setViewPromissoryModal(false)} color="primary">
            Voltar
          </Button>
          <Button
            onClick={handlePrintClick}
            color="primary"
            variant="contained"
            startIcon={<PrintIcon />}
          >
            Confirmar Impressão
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal de Extrato - Onde o botão de imprimir está */}
      <Dialog
        open={viewPaymentModal}
        onClose={() => setViewPaymentModal(false)}
        fullWidth
        maxWidth="md"
      >
        <UIDialogTitle onClose={() => setViewPaymentModal(false)}>
          Extrato de {modalValues ? fullName(modalValues) : ''}
        </UIDialogTitle>
        <DialogContent>
          <Box
            mb={2}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6">
              Total Pendente:{' '}
              <span style={{ color: salesTotal > 0 ? 'red' : 'green' }}>
                {formattedCurrency(salesTotal)}
              </span>
            </Typography>
            {salesTotal > 0 && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<AttachMoneyIcon />}
                onClick={() => setModalPay(true)}
              >
                Receber Dívida
              </Button>
            )}
          </Box>

          {/* Tabela de Vendas Pendentes */}
          {loadingSales || salesInfo.loading ? (
            <Box display="flex" justifyContent="center" m={3}>
              <CircularProgress />
            </Box>
          ) : (
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Venda</TableCell>
                    <TableCell>Vendedor</TableCell>
                    <TableCell align="right">Total</TableCell>
                    <TableCell align="right">Pago</TableCell>
                    <TableCell align="right">Restante</TableCell>
                    <TableCell align="center">Data</TableCell>
                    <TableCell align="center">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {salesInfo.data &&
                    salesInfo.data.map((data) => {
                      const debt =
                        parseFloat(data.value) - parseFloat(data.amountPaid);
                      const isPaid = debt <= 0.01;
                      return (
                        <TableRow key={data.id}>
                          <TableCell>#{data.id}</TableCell>
                          <TableCell>{getUserByID(data.userId)}</TableCell>
                          <TableCell align="right">
                            {formattedCurrency(data.value)}
                          </TableCell>
                          <TableCell align="right">
                            {formattedCurrency(data.amountPaid)}
                          </TableCell>
                          <TableCell align="right">
                            {isPaid ? (
                              <Chip
                                label="Pago"
                                size="small"
                                style={{
                                  backgroundColor: '#e0f2f1',
                                  color: '#00695c',
                                }}
                              />
                            ) : (
                              <Typography
                                variant="body2"
                                style={{ color: '#d32f2f', fontWeight: 'bold' }}
                              >
                                {formattedCurrency(debt)}
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell align="center">
                            {formattedDateTime(data.moment)}
                          </TableCell>
                          <TableCell align="center">
                            <Link to={() => goToReferenceId(3, data.id)}>
                              <IconButton size="small">
                                <CallMadeIcon />
                              </IconButton>
                            </Link>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {/* Seleção de Data de Vencimento */}
          {salesTotal > 0 && (
            <Box
              mt={2}
              p={2}
              bgcolor="#f9f9f9"
              borderRadius={4}
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              <Box mr={2}>
                <Typography variant="caption" color="textSecondary">
                  Data de Vencimento da Promissória:
                </Typography>
              </Box>
              <div style={{ width: '200px' }}>
                <FormInputDate
                  value={promissoryDueDate}
                  onChange={setPromissoryDueDate}
                  label=""
                />
              </div>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {salesTotal > 0 && (
            <Button
              onClick={() => setViewPromissoryModal(true)}
              color="secondary"
              startIcon={<VisibilityIcon />}
            >
              Visualizar Promissória
            </Button>
          )}
          <Button onClick={() => setViewPaymentModal(false)} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      <UIDialogConfirm
        open={alert}
        close={closeAlert}
        data={
          deleteInfo.data ? deleteInfo : payInfo.data ? payInfo : updateInfo
        }
        messageSucess={
          payInfo.data
            ? 'Pagamento realizado com sucesso!'
            : deleteInfo.data
              ? 'Cliente excluído com sucesso!'
              : 'Operação realizada com sucesso!'
        }
        type="success"
      />
    </>
  );
};

export default ClientSearch;
